/* eslint import/no-extraneous-dependencies: 0 */
/* eslint no-underscore-dangle: 0 */
import * as Blockly from 'blockly';
import { FieldSlider } from '@blockly/field-slider';

// FieldSlider de v13 (plugin) no trae rótulo ni valor visible y usa el color del
// bloque de fondo; se agrega el rótulo "<labelText> <valor>" y fondo blanco como en el legacy.
export class EducabotSliderField extends FieldSlider {
  constructor(value, min, max, precision, validator, config) {
    // FieldNumber ignora min/max/precision posicionales si recibe cualquier
    // config; como acá siempre hay config, se reinyectan o quedan en ±Infinity.
    super(value, min, max, precision, validator, { min, max, precision, ...config });
    this.labelText_ = (config && config.labelText) || '';
  }

  showEditor_(e, quietInput) {
    super.showEditor_(e, quietInput);
    Blockly.DropDownDiv.setColour('#ffffff', '#dddddd');
  }

  dropdownCreate_() {
    const wrapper = super.dropdownCreate_();
    wrapper.classList.add('blocklyFieldSliderWrapper');

    if (this.labelText_) {
      const label = document.createElement('div');
      label.className = 'blocklyFieldSliderLabel';
      const text = document.createElement('span');
      text.className = 'blocklyFieldSliderLabelText';
      text.textContent = this.labelText_;
      const readout = document.createElement('span');
      readout.className = 'blocklyFieldSliderReadout';
      readout.textContent = String(this.getValue());
      label.appendChild(text);
      label.appendChild(readout);
      wrapper.insertBefore(label, wrapper.firstChild);
      this.readout_ = readout;
    }

    // Track de color sólido: el terciario del bloque padre si el field está en
    // un shadow, como el legacy.
    const sourceBlock = this.getSourceBlock();
    const colourSource = (sourceBlock && sourceBlock.isShadow() && sourceBlock.getParent())
      || sourceBlock;
    if (colourSource) {
      this.sliderInput.style.setProperty('--educabot-slider-fill', colourSource.getColourTertiary());
    }

    return wrapper;
  }

  onSliderChange_() {
    super.onSliderChange_();
    if (this.readout_) {
      this.readout_.textContent = String(this.getValue());
    }
  }

  dropdownDispose_() {
    this.readout_ = null;
    super.dropdownDispose_();
  }
}

// Medidas y colores iguales a prod. Selectores de 2 clases para ganarle al CSS
// del plugin sin depender del orden de registro.
Blockly.Css.register(`
.blocklyFieldSliderWrapper.fieldSliderContainer {
  display: block;
  height: auto;
  width: auto;
}

.blocklyFieldSliderWrapper .blocklyFieldSliderLabel {
  font-family: "Helvetica Neue", "Segoe UI", Helvetica, sans-serif;
  font-size: 0.65rem;
  color: rgb(87, 94, 117);
  margin: 8px;
}

.blocklyFieldSliderWrapper .blocklyFieldSliderLabelText {
  font-weight: bold;
}

.blocklyFieldSliderWrapper .blocklyFieldSliderReadout {
  margin-left: 10px;
}

.blocklyFieldSliderWrapper .fieldSlider {
  width: 150px;
  margin: 8px 8px 20px;
}

.blocklyFieldSliderWrapper .fieldSlider::-webkit-slider-runnable-track {
  background: var(--educabot-slider-fill, #547ab2);
  border-radius: 11px;
  height: 22px;
}

.blocklyFieldSliderWrapper .fieldSlider::-webkit-slider-thumb {
  -webkit-appearance: none;
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 0 0 4px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  height: 26px;
  width: 26px;
  margin-top: -2px;
}

.blocklyFieldSliderWrapper .fieldSlider::-moz-range-track {
  background: var(--educabot-slider-fill, #547ab2);
  border-radius: 11px;
  height: 22px;
}

.blocklyFieldSliderWrapper .fieldSlider::-moz-range-thumb {
  background: #fff;
  border: none;
  border-radius: 50%;
  box-shadow: 0 0 0 4px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  height: 26px;
  width: 26px;
}
`);
